module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-清除文本.b6db7.png";